import { Directive, TemplateRef, inject } from "@angular/core";

@Directive({ 
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[accordionTitle]" })
export class AccordionTitleDirective {
    templateRef = inject<TemplateRef<any>>(TemplateRef);
}
